// extracted by mini-css-extract-plugin
export default {"truncated":"ad7dj7"};